import PropTypes from "prop-types";

import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import StoreInfoAndSelection from "./StoreInfoAndSelection";
import DeliveryAddressSelection from "./DeliveryAddressSelection";
import FilterStoreUtil from "./FilterStoreUtil";
import { connect } from "shared/src/stores/storeConnect";
import Customer from "shared/src/types/customer/Customer";
import CustomerStore from "../../../../stores/CustomerStore";
import { StoreType } from "../../../../datatypes/Store";
import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";

/**
 * Decides what to display: either both: the delivery address selection AND the mario store selection
 * or just the delivery address selection.
 */
type Props = {
    store: StoreType | undefined | null;
    onStoreSelect: () => void;
    hideTitle: boolean;
    customer: Customer | null | undefined;
    renderInPopover: boolean;
};

class AddressSelectionSwitch extends React.Component<Props> {
    getAddressSelectionPanel() {
        return (
            <DeliveryAddressSelection
                onAddressSelect={this.props.onStoreSelect}
                renderInPopover={this.props.renderInPopover}
            />
        );
    }

    getTabSelection() {
        return (
            <div>
                <Tabs defaultActiveKey={1}>
                    <Tab eventKey={1} title={this.context.intl.formatMessage({ id: "EX_TAB_TITLE_DELIVERY_ADDRESS" })}>
                        {this.getAddressSelectionPanel()}
                    </Tab>
                    <Tab eventKey={2} title={this.context.intl.formatMessage({ id: "EX_TAB_TITLE_STORE_SELECTION" })}>
                        <StoreInfoAndSelection
                            hideTitle={this.props.hideTitle}
                            renderInPopover={this.props.renderInPopover}
                            store={this.props.store}
                            inMobileMenu={false}
                            onStoreSelect={this.props.onStoreSelect}
                            deliveryAddresses={FilterStoreUtil.getCustomerDeliveryAddresses(this.props.customer)}
                        />
                    </Tab>
                </Tabs>
            </div>
        );
    }

    render() {
        if (CountryUtil.isMarioCountry()) {
            return this.getTabSelection();
        }
        return this.getAddressSelectionPanel();
    }

    static contextTypes = { intl: PropTypes.object };
}

export default connect(
    {
        stores: [
            [
                CustomerStore,
                (s: typeof CustomerStore) => ({
                    customer: s.getCustomer()
                })
            ]
        ]
    },
    AddressSelectionSwitch
);
